import { useMemo } from "react";

// material-ui
import { Theme } from "@mui/material/styles";
import { Box, useMediaQuery } from "@mui/material";

// project-imports
import Search from "./Search";
import Profile from "./Profile";
import Localization from "./Localization";
import Notification from "./Notification";
import MobileSection from "./MobileSection";

import useConfig from "hooks/useConfig";
import DrawerHeader from "layout/MainLayout/Drawer/DrawerHeader";

// type
import { MenuOrientation } from "types/config";
import useAuth from "hooks/useAuth";
import FullScreen from "./FullScreen";

// ==============================|| HEADER - CONTENT ||============================== //

const HeaderContent = () => {
  const { i18n, menuOrientation } = useConfig();

  const { user } = useAuth();

  const downLG = useMediaQuery((theme: Theme) => theme.breakpoints.down("lg"));

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const localization = useMemo(() => <Localization />, [i18n]);

  return (
    <>
      {menuOrientation === MenuOrientation.HORIZONTAL && !downLG && (
        <DrawerHeader open={true} />
      )}
      {!downLG && <Search />}
      {!downLG && localization}
      {downLG && <Box sx={{ width: "100%", ml: 1 }} />}
      {user && Number(user.user_type) !== 6 && <Notification />}
      <FullScreen />
      {!downLG && <Profile />}
      {downLG && <MobileSection />}
    </>
  );
};

export default HeaderContent;
